<template lang="pug">
  .base_ball_root
    .ball(
      v-if="!isImage"
      :style="{'width': `${size}px`, 'height': `${size}px`, 'border': ballBorder ,'background': ballColor, 'color': fontColor}"
    )
      .ball_num {{ number }}
    BaseImg.dice(
      v-if="isImage"
      :imgType="'icons'"
      :imgName="imgName(number)"
      :imgSize="size"
    )
</template>

<script>
import colors from './color.js'
import BaseImg from '@/components/BaseImg'

export default {
  components: {
    BaseImg
  },

  props: {
    // 種類: pk10, 快3, 28系列, 六合彩系列, 其他
    gameCategory: {
      type: [String, Number],
      required: true
    },
    size: {
      type: Number,
      required: true
    },
    number: {
      type: Number,
      required: true
    }
  },

  computed: {
    ballColor () {
      const colorMsg = this.getBallColorMsg()
      const text = colorMsg.reduce((text, config, index) => {
        if (index === colorMsg.length - 1) return text.concat(`${config}`)
        return text.concat(`${config},`)
      }, '')

      return this.isWhiteBall ? `${text}` : `linear-gradient(${text})`
    },

    isWhiteBall () {
      return this.gameCategory === 'BL28' && [0, 13, 14, 27].includes(this.number)
    },

    isImage () {
      return this.gameCategory === 'FAT3' || this.gameCategory === 'YXX3'
    },

    fontColor () {
      if (this.isWhiteBall) return '#303038'
      return '#FFF'
    },

    ballBorder () {
      if (this.isWhiteBall) return 'solid 2px #c0c0c8'
      return 'none'
    }
  },

  methods: {
    // 依照 color.js 找到對應色碼
    getBallColorMsg () {
      let ballColorMsg = []
      const refColorKey = this.searchColorKey() // 在 color.js 找到對應彩種的 key 值
      const refColorList = colors[refColorKey] // 對應彩種球號清單

      Object
        .keys(refColorList)
        .forEach(refNum => {
          const translNum = this.numMakeUpZero(this.number) // 這裏避免用 3 會搜尋到 13, 因此單數皆補上 0, 變成 03 後再做搜尋
          if (refNum.includes(translNum) || refColorKey === 'default') {
            ballColorMsg = refColorList[refNum]
          }
        })
      return ballColorMsg
    },

    searchColorKey () {
      const colorKeys = Object.keys(colors)
      const colorKey = colorKeys.includes(this.gameCategory) ? this.gameCategory : 'default'
      return colorKey
    },

    numMakeUpZero (num) {
      return num < 10 ? '0' + num : num
    },

    imgName (number) {
      let result = ''
      switch (this.gameCategory) {
        case 'FAT3':
          result = `dice-${number}`
          break
        case 'YXX3':
          result = `dice-yxx3-${number}`
          break

        default:
          break
      }
      return result
    }
  }
}
</script>

<style lang="stylus">
  @import '~@/assets/styleConsts.styl'
  @import './BaseBall.styl'
</style>
